/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import axios2 from '@/api';
import router from '@/router';
import i18n from '@/i18n';
import some from 'lodash/some';
import get from 'lodash/get';

const jwtDecode = require('jwt-decode');

const address = process.env.VUE_APP_BASE_URL;

const user = {
  authenticated: false,
};

function login(username, password) {
  return axios.post(address + 'oauth/token', {
      username,
      password,
      client_secret: process.env.VUE_APP_CLIENT_SECRET,
      grant_type: 'password',
      client_id: process.env.VUE_APP_CLIENT_ID,
    })
    .then((auth) => {
      // login successful if there's a jwt token in the response
      if (auth.data.access_token) {
        this.user.authenticated = true;
        localStorage.setItem('access_token', JSON.stringify(auth.data.access_token));
        axios.get(address + 'api/v1/user/info', {
            headers: {
              Authorization: `Bearer ${auth.data.access_token}`,
              'Accept-Language': `${localStorage.getItem('language') ? localStorage.getItem('language') : 'en'}`,
            },
          })
          .then((response) => {
            const userComp = {
              access_token: auth.data.access_token,
              refresh_token: auth.data.refresh_token,
              userInfo: response.data,
            };
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(userComp));
            const {
              language,
            } = userComp.userInfo.data.individual;
            i18n.locale = language;
            localStorage.setItem('language', language);
            switch (userComp.userInfo.data.role) {
              case 'tutor':
                router.push({
                  name: 'Home',
                });
                break;
              case 'teacher':
                router.push({
                  name: 'Classi',
                });
                break;
              default:
                break;
            }
            return userComp;
          });
      }
    })
    .catch(error => Promise.reject(error));
}

// Logout
function logout() {
  localStorage.removeItem('user');
  localStorage.removeItem('access_token');
  localStorage.removeItem('classroom_id');
  this.user.authenticated = false;
  for (let i = 1; i < 999; i += 1) {
    window.clearInterval(i);
  }
}

// LostPassword
function lostPassword(username) {
  return axios.post(address + 'api/v1/lost-password', {
      username,
    })
    .then(() => {
      router.push({
        name: 'Login',
      });
    })
    .catch(error => Promise.reject(error));
}

function checkToken(token) {
  return axios.post(address + 'api/v1/check-token', {
      token,
    })
    .then((auth) => {
      if (auth.data && auth.data.first_access) {
        router.push({
          name: 'ResetPassword',
          query: {
            token,
          },
        });
      } else {
        router.push({
          name: 'Login',
        });
      }
      return auth.data;
    })
    .catch(error => Promise.reject(error));
}

function profile() {
  return axios2.get('user/info')
    .then(response => response)
    .catch(error => Promise.reject(error));
}

function updateProfile(user1) {
  return axios2.put('user/profile', user1)
    .then(() => {})
    .catch(error => Promise.reject(error));
}

function resetPassword(password, token) {
  return axios.put(address + 'api/v1/password', {
      password,
      token,
    })
    .then(() => {
      router.push({
        name: 'Login',
      });
    })
    .catch(error => Promise.reject(error));
}

function getUserInfo() {
  if (this.isAuthorized()) {
    const item = JSON.parse(localStorage.getItem('user'));
    if (item) {
        return get(item, ['userInfo', 'data']);
    }
    return {};
  }
  return {};
}

function isAuthorized() {
  this.checkAuth();
  return this.user.authenticated;
}

function getToken() {
  const item = JSON.parse(localStorage.getItem('access_token'));
  return item;
}

function checkAuth() {
  const jwt = this.getToken();
  if (jwt) {
    if (this.isTokenExpired(jwt)) {
      this.user.authenticated = false;
    } else {
      this.user.authenticated = true;
    }
  } else {
    this.user.authenticated = false;
  }
}

function getTokenExpirationDate(token) {
  if (!token) {
    return null;
  }
  const decoded = jwtDecode(token);

  if (typeof decoded.exp === 'undefined') {
    return null;
  }

  const d = new Date(0); // The 0 here is the magic, which sets the date to the epoch
  d.setUTCSeconds(decoded.exp);

  return d;
}

function isTokenExpired(token, offsetSeconds) {
  const tokenSaved = !token ? this.getToken() : (token || {});
  const d = this.getTokenExpirationDate(tokenSaved);
  const offset = offsetSeconds || 0;
  if (d === null) {
    return true;
  }
  // Token expired?
  return d.valueOf() < (new Date().valueOf() + (offset * 1000));
}

function getRoles() {
  const item = localStorage.getItem('user');
  if (item) {
    const data = JSON.parse(item);
    return [].concat(data.userInfo.data.role);
  }
  return [];
}

function getRole() {
  const roles = this.getRoles();
  if (roles && roles.length > 0) {
    return roles[0]; // TODO gestire ruoli multipli
  }
  return '';
}

function hasRole(role) {
  if (!role) {
    return false;
  }
  const roles = this.getRoles();
  const found = some(roles, r => r.toUpperCase() === role.toUpperCase());

  return found;
}

function hasRoles(roles) {
  if (!roles || !Array.isArray(roles)) {
    return false;
  }
  let ret = false;
  for (let i = 0; i < roles.length; i += 1) {
    const role = roles[i];
    ret = this.hasRole(role);
    if (ret === true) {
      break;
    }
  }
  return ret;
}

function getServerTime() {
  return axios2.get('server-time')
    .then(result => result.data)
    .catch(error => Promise.reject(error));
}

export const authService = {
  user,
  login,
  logout,
  getUserInfo,
  isAuthorized,
  getToken,
  checkAuth,
  getTokenExpirationDate,
  isTokenExpired,
  getRoles,
  getRole,
  hasRole,
  hasRoles,
  checkToken,
  lostPassword,
  profile,
  resetPassword,
  updateProfile,
  getServerTime,
};
